module.exports = {"510725100":"文昌镇","510725101":"长卿镇","510725102":"许州镇","510725103":"黎雅镇","510725105":"卧龙镇","510725106":"观义镇","510725107":"玛瑙镇","510725108":"石牛镇","510725109":"自强镇","510725110":"仁和镇","510725111":"双板镇","510725112":"金龙镇","510725113":"文兴镇","510725114":"演武镇","510725115":"宏仁镇","510725217":"宝石乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510725.json
// module id = 2436
// module chunks = 0